/* ============================================================================
 * ตัวเลือกกลางของเมนู "พาร์ตเนอร์" (page/admin/partners.js)
 *
 * ค่าคงที่ทุกตัวในไฟล์นี้ต้องตรงกับฝั่ง backend
 * (Munera-Backend/modules/admin/partner/partner.constant.js)
 * และตัวเลือกที่ผู้สมัครเห็นตอนกรอกใบสมัคร
 * (Munera-Frontend/src/page/homepage/partner_option.js)
 * ถ้าเพิ่มที่ฝั่งใดต้องเพิ่มอีกสองฝั่งด้วย ไม่งั้นค่าที่บันทึกไว้จะแสดงเป็นขีดกลาง
 * ========================================================================== */

/* ------------------------------------------------------------ สถานะใบสมัคร */
/* tone/tint = สีประจำสถานะ ผ่านการตรวจ contrast บนพื้นขาวแล้ว (ชุดเดียวกับหน้าลูกค้า)
   flow = สถานะที่อยู่ในคิวงานตรวจ ใช้เรียงเป็นแถบตัวกรองด้านบนตาราง */
export const PARTNER_STATUSES = [
  { value: "pending", label: "partner_status_pending", icon: "", tone: "#b45309", tint: "#fef3c7" },
  { value: "reviewing", label: "partner_status_reviewing", icon: "", tone: "#1d4ed8", tint: "#dbeafe" },
  { value: "approved", label: "partner_status_approved", icon: "", tone: "#15803d", tint: "#dcfce7" },
  { value: "rejected", label: "partner_status_rejected", icon: "", tone: "#b91c1c", tint: "#fee2e2" },
  { value: "suspended", label: "partner_status_suspended", icon: "", tone: "#57534e", tint: "#e7e5e4" },
];

const UNKNOWN_STATUS = { value: "", label: "-", icon: "", tone: "#94a3b8", tint: "#e2e8f0" };

export const statusMeta = (value) => PARTNER_STATUSES.find((item) => item.value === value) || UNKNOWN_STATUS;

/* สถานะที่ยังรอผู้ดูแลตัดสิน — การ์ด "รอดำเนินการ" นับจากชุดนี้ */
export const OPEN_STATUSES = ["pending", "reviewing"];

/* เปลี่ยนจากสถานะไหนไปไหนได้บ้าง — ต้องตรงกับ STATUS_TRANSITIONS ฝั่ง backend
   หน้าเว็บใช้ตัดสินว่าจะโชว์ปุ่มไหนบ้าง ส่วน backend เป็นด่านจริงที่ปฏิเสธคำขอ
   (ใบที่ไม่อนุมัติแล้วพลิกกลับไม่ได้ ต้องให้ผู้สมัครยื่นใบใหม่) */
export const STATUS_TRANSITIONS = {
  pending: ["reviewing", "approved", "rejected"],
  reviewing: ["pending", "approved", "rejected"],
  approved: ["suspended"],
  suspended: ["approved"],
  rejected: [],
};

/* สถานะที่ต้องกรอกเหตุผลก่อนถึงจะเปลี่ยนได้ — ผู้สมัครมีสิทธิ์รู้ว่าเพราะอะไร
   และทีมที่รับสายต่อต้องตอบได้โดยไม่ต้องไปตามหาคนที่กดปุ่ม (backend บังคับอีกชั้น) */
export const REASON_REQUIRED_STATUSES = ["rejected", "suspended"];

/* --------------------------------------------------------------- ประสบการณ์ */
export const EXPERIENCE_OPTIONS = [
  { value: "none", label: "partner_exp_none" },
  { value: "lt1", label: "partner_exp_lt1" },
  { value: "1to3", label: "partner_exp_1to3" },
  { value: "3to5", label: "partner_exp_3to5" },
  { value: "gt5", label: "partner_exp_gt5" },
];

export const EXPERTISE_OPTIONS = [
  { value: "condo", label: "partner_expertise_condo" },
  { value: "house", label: "partner_expertise_house" },
  { value: "townhome", label: "partner_expertise_townhome" },
  { value: "land", label: "partner_expertise_land" },
  { value: "commercial", label: "partner_expertise_commercial" },
  { value: "rent", label: "partner_expertise_rent" },
  { value: "project", label: "partner_expertise_project" },
  { value: "luxury", label: "partner_expertise_luxury" },
];

export const DOC_TYPES = [
  { value: "id_card", label: "partner_doc_id_card" },
  { value: "passport", label: "partner_doc_passport" },
];

/* ------------------------------------------------------------ การเรียงลำดับ */
/* key ต้องตรงกับ SORT_ORDERS ใน partner.repository.js ฝั่ง backend */
export const SORTS = [
  { value: "submitted_desc", label: "partner_sort_submitted_desc" },
  { value: "submitted_asc", label: "partner_sort_submitted_asc" },
  { value: "status_asc", label: "partner_sort_status" },
  { value: "name_asc", label: "partner_sort_name" },
];

/* --------------------------------------------------------------- ตัวช่วยแสดงผล */
/** ป้ายชื่อของค่าที่เลือกจากรายการคงที่ — ไม่เจอก็คืนค่าว่าง ไม่โชว์รหัสดิบ */
export const optionLabel = (options, value, t) => {
  const found = options.find((item) => item.value === value);
  return found ? t(found.label) : "";
};

/** 0812345678 -> 081-234-5678 (สูตรเดียวกับหน้าผู้ใช้งาน) */
export const fmtPhone = (phone = "") => {
  const digits = String(phone).replace(/\D/g, "");
  if (digits.length !== 10) return phone || "-";
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/** "1.2 MB" — ใช้โชว์ใต้ชื่อไฟล์เอกสารที่ผู้สมัครแนบมา */
export const fileSize = (bytes) => {
  const size = Number(bytes || 0);
  if (!size) return "";
  const mb = size / (1024 * 1024);
  return mb >= 1 ? `${mb.toFixed(1)} MB` : `${Math.max(1, Math.round(size / 1024))} KB`;
};

/** ที่อยู่เต็มจากฟิลด์ที่แยกกันเก็บ — ช่องที่ว่างถูกตัดออกไม่ให้เหลือช่องว่างซ้อน */
export const fullAddress = (item = {}) =>
  [item.address, item.subdistrict, item.district, item.province, item.postcode]
    .filter((part) => !!String(part || "").trim())
    .join(" ");

/* ไฟล์ที่พรีวิวเป็นรูปได้ — PDF โชว์เป็นไอคอนกับชื่อไฟล์แทน
   (เอกสารยืนยันตัวตนรับเฉพาะรูปกับ PDF อยู่แล้ว ดู DOC_ACCEPT ของฟอร์มใบสมัคร) */
export const isImageDoc = (doc = {}) => String(doc.mime_type || "").startsWith("image/");
